//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faTimes, faAngleLeft } from '@fortawesome/pro-regular-svg-icons';

const VISUAL_SEARCH_SIDEBAR_BODY_CLASS = 'visual-search-sidebar-open';
// Match $zindex-modal so the panel stacks above the site header on mobile.
const MOBILE_VISUAL_SEARCH_SIDEBAR_Z_INDEX = 1050;

export default {
  name: 'FileSearchSidebar',
  props: {
    id: String,
    title: String,
    hideAllSidebar: String,
    backButton: Boolean,
    shown: Boolean,
    hidden: Boolean,
  },
  data() {
    return {
      faTimes,
      faAngleLeft,
      mobileSidebarZIndex: MOBILE_VISUAL_SEARCH_SIDEBAR_Z_INDEX,
    };
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
    document.body.classList.remove(VISUAL_SEARCH_SIDEBAR_BODY_CLASS);
  },
  methods: {
    emitShown() {
      this.$emit('shown');
      // I try to do it with head() > bodyAttrs > class - but it dont work inside layout
      // disabled body scroll when sidebar is opened
      document.body.classList.add('modal-open');
      document.body.classList.add(VISUAL_SEARCH_SIDEBAR_BODY_CLASS);
    },
    emitHidden() {
      this.$emit('hidden');
      document.body.classList.remove('modal-open');
      document.body.classList.remove(VISUAL_SEARCH_SIDEBAR_BODY_CLASS);
    },
  },
};
